import { render, staticRenderFns } from "./LimitStudyPlan.vue?vue&type=template&id=a07cf594&scoped=true"
import script from "./LimitStudyPlan.vue?vue&type=script&lang=js"
export * from "./LimitStudyPlan.vue?vue&type=script&lang=js"
import style0 from "./LimitStudyPlan.vue?vue&type=style&index=0&id=a07cf594&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a07cf594",
  null
  
)

export default component.exports